export default __webpack_public_path__ + "static/media/tmp_car_detail_image.d78db761.png";